import { useCallback, useMemo } from 'react';
import { ContentColors, Flex, IconRefresh, Typography } from '@banhala/ui-kit';
import type { HeadlineReloadOneLineProps } from './types';
import { bridge, isNil, renderHTMLToText } from '../../../../utils';

const RELOAD_ICON_SIZE = 16;
const RELOAD_CIRCLE_SIZE = 28;
const RELOAD_TOUCH_SIZE = 40;

export const HeadlineReloadOneLine = ({
  header,
  onReload,
}: HeadlineReloadOneLineProps) => {
  const titleElement = useMemo(() => {
    if (isNil(header)) return null;
    return renderHTMLToText(header.item.title);
  }, [header]);

  const handlePressReload = useCallback(() => {
    if (isNil(header)) return;
    bridge.logAnalyticsEvent({
      name: 'CLICK_HEADLINE_ONE_LINE_RELOAD',
      analytics: header.logging.analytics,
      ably_only_log: header.logging.ably_only_log,
    });
    onReload?.();
  }, [header, onReload]);

  if (isNil(header)) {
    return null;
  }

  return (
    <Flex.Row
      padding={{ horizontal: 16, vertical: 16 }}
      alignItems="center"
      gap={4}
    >
      <Flex flexShrink={1}>
        <Typography type="h5" numberOfLines={1} color="content_primary">
          {titleElement}
        </Typography>
      </Flex>

      <Flex
        width={RELOAD_TOUCH_SIZE}
        height={RELOAD_TOUCH_SIZE}
        alignItems="center"
        justifyContent="center"
        onPress={handlePressReload}
      >
        <Flex.Center
          width={RELOAD_CIRCLE_SIZE}
          height={RELOAD_CIRCLE_SIZE}
          borderRadius={RELOAD_CIRCLE_SIZE / 2}
          borderWidth={1}
          borderColor="gray20"
        >
          <IconRefresh
            width={RELOAD_ICON_SIZE}
            height={RELOAD_ICON_SIZE}
            fill={ContentColors.content_pink_primary}
          />
        </Flex.Center>
      </Flex>
    </Flex.Row>
  );
};
